<template>
    <div class="modal">
        <div class="vertical-center">
            <h2>Sleutel genereren</h2>
        </div>

        <p class="mb-m mt-s">Vul een naam in voor je nieuwe sleutel</p>
        <div class="modal-content">
            <q-input labelPosition="inside" id="newName" v-model="name" placeholder="Naam API key (e.g. Datawarehouse)"
                >Naam van de API key</q-input
            >
        </div>

        <div class="footer space-between flexEnd">
            <q-button @click="createKey()">Genereer sleutel</q-button>
        </div>
    </div>
</template>

<script>
import { ORGANISATION_CREATE_API_KEY } from '@/graphql/mutations';

export default {
    data() {
        return {
            name: ''
        };
    },
    methods: {
        createKey() {
            const organisationId = this.$store.getters.getCurrentOrganisation.id;

            return this.$apollo
                .query({
                    query: ORGANISATION_CREATE_API_KEY,
                    variables: { organisationId, name: this.name },
                    fetchPolicy: 'no-cache'
                })
                .then(result => {
                    this.$emit('close', result.data.org_addApiKey);
                    this.$store.commit('notify', { type: 'success', message: 'Nieuwe sleutel succesvol aangemaakt' })
                })
                .catch(err => {
                    this.$store.commit('notify', { type: 'danger', message: 'Er ging iets fout tijdens het aanmaken van jouw sleutel' })
                });
        }
    }
};
</script>

<style lang="scss" scoped>
@import '../../../components/qds/assets/style/_variables.scss';
@import '../../../components/qds/assets/style/fonts/fonts.css';

.modal {
    width: 400px;
    display: flex;
    flex-direction: column;

    .modal-content {
        margin-bottom: 70px;

        input {
            width: 100%;
        }
    }

    .footer {
        position: absolute;
        bottom: 0;
        width: calc(100% - 80px);
        margin: 0 -40px;
        padding: 20px 40px;
        border-top: 1px solid rgb(222, 226, 230);
    }
}

.profile-right {
    margin-left: 16px;

    .name {
        font-weight: 500;
    }
    .role {
        margin-left: -2px;
    }
}

.flexEnd {
    display: flex;
    justify-content: flex-end;
}

.permission-wrapper {
    display: flex;
    margin: 40px 0px 90px;
    min-height: 100px;

    .subhead {
        font-weight: 500;
        font-size: 1.1rem;
    }

    .left {
        width: 35%;
        min-width: 200px;
        border-right: 1px solid rgb(222, 226, 230);

        .category-item {
            padding: 4px 8px;
            border: 1px solid white;
            border-radius: 4px;
            margin-right: 24px;
            margin-left: -8px;
            // margin-bottom: 8px;

            &:hover {
                border-color: rgb(222, 226, 230);
                cursor: pointer;
            }

            .active {
                color: $color-primary;
                font-weight: 500;
            }

            .count {
                color: $color-grey-5;
            }
        }
    }

    .right {
        padding: 0px 40px;
        width: calc(100% - 35%);
        max-height: 250px;
        overflow-y: scroll;
        &::-webkit-scrollbar {
            width: 8px;
        }

        /* Track */
        &::-webkit-scrollbar-track {
            background: $color-white;
            border-radius: 4px;
        }

        /* Handle */
        &::-webkit-scrollbar-thumb {
            background: $color-grey-3;
        }

        /* Handle on hover */
        &::-webkit-scrollbar-thumb:hover {
            background: $color-grey-5;
        }
    }
}

.error {
    color: red;
    font-size: 15px;
}
</style>
